/* istanbul ignore file */

export const WIDGET_SIZES = {
    NUMBER_WIDTH: 1,
    NUMBER_HEIGHT: 4,
    NUMBER_MIN_HEIGHT: 3,
    NUMBER_LARGE_HEIGHT: 6,
    MAP_WIDTH: 2,
    MAP_HEIGHT: 6,
    MAP_MIN_WIDTH: 2,
    MAP_MIN_HEIGHT: 6,
    REPORT_WIDTH: 2,
    REPORT_HEIGHT: 6,
    PROJECT_NOTES_WIDTH: 2,
    PROJECT_NOTES_HEIGHT: 6,
    SEGMENT_CIRCULAR_CHART_WIDTH: 2,
    SEGMENT_CIRCULAR_CHART_HEIGHT: 6,
    MIN_WIDTH: 1,
    MIN_HEIGHT: 4,
    MAX_HEIGHT: 10,
};
